import StoreProvider from "@/app/StoreProvider";
import CapacitorApp from "@/components/capacitor/CapacitorApp";
import { AuthProvider } from "@/contexts/AuthContext";

const Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <StoreProvider>
      <AuthProvider>
        <CapacitorApp />
        {children}
      </AuthProvider>
    </StoreProvider>
  );
};

export default Provider;
